import { strRemoveSpaces, translation as t } from "../../../../inc/helpers";
import Input from "./Input";
export default class InputEmail extends Input {
    constructor({
        container,
        input,
        label,
        error
    }) {
        super({ container, input, label, error });
    }

    _validate(value) {
        // basic browsers validation from MDN
        // see https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input/email
        // const reg = /^[\w.!#$%&'*+/=?^`{|}~-]+@[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?(?:\.[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?)*$/i;
        // stessa reg di Web.config, sarebbe da mettere da un'altra parte
        const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
        const _value = strRemoveSpaces(value);

        if (!this._required && _value === "")
            return { flag: null, msg: "" };

        if (this._required && _value === "")
            return { flag: false, msg: t("ERROR.FieldMandatory") };

        if (this._pattern && !this._pattern.test(_value)) {
            return { flag: false, msg: t("ERROR.InvalidFormat") };

        } else if (!reg.test(_value))
            return { flag: false, msg: t("ERROR.InvalidFormat") };

        if (this._minlength && _value.length < this._minlength)
            return { flag: false, msg: t("ERROR.MinChars", [this._minlength]) };

        if (this._maxlength && _value.length > this._maxlength)
            return { flag: false, msg: t("ERROR.MaxChars", [this._maxlength]) };

        return { flag: true, msg: "" };
    }
}